import React, { Component, ReactNode } from "react";
import {
  Text,
  Platform,
  Image,
  ImageSourcePropType,
  Pressable,
  TouchableHighlight,
} from "react-native";
import { RectButton } from "react-native-gesture-handler";
import { Theme } from "@app/ui";

let PointerInteractionView;

if (Platform.OS === "ios") {
  PointerInteractionView = require("@thefunbots/react-native-pointer-interactions")
    .PointerInteractionView;
}

interface Props {
  children: any;
  onPress?: any;
  style?: any;
  disabled?: boolean;
  transparency?: Number;
  highlightColor?: string;
  backgroundColor?: string;
}

export default ({
  children,
  onPress,
  style,
  disabled,
  highlightColor = Theme.colors.text,
  transparency,
  backgroundColor = Theme.colors.primary,
}: Props) => {
  const renderAndroid = () => {
    return (
      <Pressable
        onPress={onPress}
        android_ripple={{ color: highlightColor }}
        style={[style]}
        disabled={disabled}
      >
        {children}
      </Pressable>
    );
  };

  const renderiOS = () => {
    return transparency ? (
      <TouchableHighlight onPress={onPress} style={style}>
        {children}
      </TouchableHighlight>
    ) : (
      <RectButton
        onPress={onPress}
        style={style}
        underlayColor={highlightColor}
      >
        {children}
      </RectButton>
    );
  };

  const renderWeb = () => {
    return (
      <Pressable
        onPress={onPress}
        style={[{ cursor: "pointer" }, style]}
        disabled={disabled}
      >
        {children}
      </Pressable>
    );
  };

  return Platform.select({
    ios: renderiOS(),
    android: renderAndroid(),
    default: renderWeb(),
  });
};
